import { Button } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import React, { useContext } from 'react';
import { trackClickOnReadMoreOrganizerDescription } from '../../tracking/analytics';
import { ReadMoreContext } from './context';
import './ReadMore.scss';
import { ReadMoreToggleProps } from './types';

const readMoreToggleDefaults: ReadMoreToggleProps = {
    labels: {
        show: gettext('Show more'),
        hide: gettext('Show less'),
    },
};

const handleOnClick = (state: boolean, callback?: Function) => {
    trackClickOnReadMoreOrganizerDescription(state);
    callback?.(state);
};

export const ReadMoreToggle: React.FunctionComponent<ReadMoreToggleProps> = (
    props,
) => {
    const { isExpanded, setExpanded, isClamped } = useContext(ReadMoreContext);

    if (!isClamped) {
        return null;
    }

    return (
        <div className="read-more__toggle">
            <Button
                data-testid="read-more-toggle"
                style="none"
                onClick={() => {
                    handleOnClick(!isExpanded, setExpanded);
                }}
            >
                <span className="eds-link">
                    {isExpanded ? props.labels?.hide : props.labels?.show}
                </span>
            </Button>
        </div>
    );
};

ReadMoreToggle.defaultProps = readMoreToggleDefaults;
